import { render, staticRenderFns } from "./PlanType.vue?vue&type=template&id=174d2ad0"
import script from "./PlanType.vue?vue&type=script&lang=js"
export * from "./PlanType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports